module.exports = __webpack_public_path__ + "static/media/21.ac602fe8.jpeg";